import { SteeringWalletBasicInfoFragment, Unit_Of_Measure } from '@occc/graphql';

import { useField } from 'react-final-form';
import { WalletCurrencyInputField } from './WalletCurrencyInputField';
import { WalletAmountInputField } from './WalletAmountInputField';

import { walletConfigurationBasisToLabelMap } from '../constants';

type WalletValueInputProps = {
  fieldArrayName: string;
};

export const WalletValueInput = ({ fieldArrayName }: WalletValueInputProps) => {
  const walletFieldName = `${fieldArrayName}.wallet`;
  const {
    input: { value: selectedWallet },
  } = useField<SteeringWalletBasicInfoFragment | null>(walletFieldName, {
    subscription: { value: true },
  });

  if (!selectedWallet || !selectedWallet.configuration || !selectedWallet.configuration.basis) {
    return null;
  }

  const periodLabel = walletConfigurationBasisToLabelMap[selectedWallet.configuration.basis];

  if (selectedWallet.configuration.unitOfMeasure === Unit_Of_Measure.Amount) {
    return <WalletCurrencyInputField fieldArrayName={fieldArrayName} periodLabel={periodLabel} />;
  }

  if (selectedWallet.configuration.unitOfMeasure === Unit_Of_Measure.Unit) {
    return <WalletAmountInputField fieldArrayName={fieldArrayName} periodLabel={periodLabel} />;
  }

  return null;
};
